module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av483-99f029b8423f742ecc426954bb6fb841.jpg";